"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDefaultCategoryProductImage = exports["default"] = void 0;
var getDefaultProductImage = function getDefaultProductImage(imageType, language, productData) {
  var findImageAndMapImages = function findImageAndMapImages(imageType) {
    var _productData$product;
    var defaultProductImage = productData === null || productData === void 0 ? void 0 : (_productData$product = productData.product) === null || _productData$product === void 0 ? void 0 : _productData$product.images.find(function (image) {
      return image[imageType];
    });
    if (!defaultProductImage) return false;
    var newProductImages = [];
    if (defaultProductImage) {
      var _productData$product2;
      (_productData$product2 = productData.product) === null || _productData$product2 === void 0 ? void 0 : _productData$product2.images.forEach(function (image) {
        if (!image[imageType]) {
          newProductImages.push(image);
        }
      });
    }
    newProductImages.unshift(defaultProductImage);
    return newProductImages;
  };
  var defaultAllegroImage = imageType[language] === "allegro";
  var defaultArrangedImage = imageType[language] === "arranged";
  if (defaultAllegroImage) {
    return findImageAndMapImages("allegroImage");
  } else if (defaultArrangedImage) {
    return findImageAndMapImages("arrangedImage");
  }
  return false;
};
var getDefaultCategoryProductImage = function getDefaultCategoryProductImage(imageType, language, product) {
  if (!product) return false;
  var defaultImage;
  if (imageType[language] === "allegro") {
    product.images.find(function (image) {
      if (image.allegroImage) {
        defaultImage = image;
      }
    });
  } else if (imageType[language] === "arranged") {
    product.images.find(function (image) {
      if (image.arrangedImage) {
        defaultImage = image;
      }
    });
  }
  return defaultImage;
};
exports.getDefaultCategoryProductImage = getDefaultCategoryProductImage;
var _default = getDefaultProductImage;
exports["default"] = _default;